import React, { useState } from 'react'
import Button from '../ui/Button'
import { useUser } from '../hooks/useUser'
import AddAddress from '../components/Address/AddAddress'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import AnimatePage from '../components/AnimatePage'

function Address() {

    const { data: user } = useUser()

    const [isAddOpen, setisAddOpen] = useState(false)
    const queryClient = useQueryClient()

    //Delete

    const { mutate } = useMutation({
        mutationFn: async (id) => {
            return apiClient.delete(`/address/delete?id=${id}`)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['user'])
        }
    })

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this address?")) {
            mutate(id)
        }
    }

    return (
        <AnimatePage>
            <div className='w-full relative'>
                {/* Head and adding address */}
                <div className='space-y-5'>
                    <h3 className="font-medium text-lg md:text-2xl">Your addresses {`(${user?.address?.length})`}</h3>
                    <Button onClick={() => setisAddOpen(!isAddOpen)}>Add New Address</Button>
                    {isAddOpen && <AddAddress onClose={() => setisAddOpen(false)} />}
                </div>


                {/* View Addresses */}
                <div className="w-full relative mt-10 space-y-5">
                    <h3 className="font-medium text-lg md:text-2xl">Default addresses</h3>

                    {/* Addresses */}
                    <div className="flex flex-wrap gap-5">
                        {user?.address?.length && user?.address?.map((add, i) => (
                            <div key={i} className='bg-white shadow shadow-white/50 border max-w-[400px] w-full'>
                                <div className="p4 font-medium p-4 py-2 bg-gray-50 border-b">{add?.AddressOne}</div>

                                {/* conten */}
                                <div className='text-gray-500 text-sm space-y-2 p-4'>
                                    <p>{`${add?.firstname} ${add?.lastname}`}</p>
                                    <p>{add?.phone}</p>
                                    <p>{add?.AddressOne}</p>
                                    <p>{add?.AddressTwo}</p>
                                    <p>{`${add?.country} ${add?.city}`}</p>
                                </div>

                                {/* delete */}
                                <div className="p-0.5 px-4 pb-5">
                                    <Button white onClick={() => handleDelete(add?.id)}>Delete</Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </AnimatePage>
    )
}

export default Address